export const environment = {
  projectName: 'EMiRLD',
  defaultTheme: 'EMiRLD',
  production: false,
  name: 'dev',
  version: '1.4.0',
  region: 'us-gov-west-1',
  url: 'https://emirld-dev.pavcongems.com/',
  endpoint: 'https://emirld-be-dev.pavcongems.com',
  refreshEndpoint: 'https://template-cognito-sample-dev.pavcongems.com/auth/refreshToken',

  sandboxEnabled: false,
  uamUrl: 'https://test-dev.pavcongems.com//',
  cookieInfo: {
    domain: '.pavcongems.com',
  }
};
